import { Box, Tab, Tabs, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { newInventoryTabs } from "./newInvetoryTabs";
import { TabPanel } from "views/Closeouts-Settlements/TabPanel";
import { a11yProps, useStyles } from "views/Closeouts-Settlements/allProps";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch, useSelector } from "react-redux";
import { GlobalBox } from "components/Box/GlobalBox";
import RegularButton from "components/CustomButtons/Button";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import StorageIcon from "@material-ui/icons/Storage";
import { validateObject } from "helpers/validateObject";
import { blue, green } from "@material-ui/core/colors";
import CachedIcon from "@material-ui/icons/Cached";
import { getInventoryExistence } from "redux/actions/inventories/inventoriesAction";
import DeleteSweepIcon from "@material-ui/icons/DeleteSweep";
import { closeDeleteInventory } from "redux/actions/inventories/inventoriesAction";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";
import { useToggle } from "hooks/useToggle";
import { ModalV2 } from "components/Modal/ModalV2";
import { resetTableControls } from "redux/actions/inventories/inventoriesAction";
import { getDecimalFormat } from "helpers/getNumberFormats";
import { getInventoryByType } from "redux/actions/inventories/inventoriesAction";
import { PERMISSIONS } from "router/permissions";
import { markInventoryLoaded } from "redux/actions/inventories/inventoriesAction";

export const InventoryDetails = () => {
  const hist = useHistory();
  const dispatch = useDispatch();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { rules } = useSelector(({ login }) => login);
  const { units } = useSelector(({ unitsReducer }) => unitsReducer);
  const { tanks } = useSelector(({ tanks }) => tanks);
  const { inventory, station } = useSelector(
    ({ inventories }) => inventories
  );
  const {
    totalKgLocal,
    totalKgMobile,
    totalKgStationary,
    totalKgStorages,
    totalKgShipments,
  } = inventory;
  const [value, setValue] = useState(0);
  const [closeInventoryModal, setCloseInventoryModal] = useToggle();
  const [deleteInventoryModal, setDeleteInventoryModal] = useToggle();
  const {
    INVENTORIES_CONTROL_RECALCULATE,
    INVENTORIES_CLOSE,
    INVENTORIES_CONTROL_DELETE,
  } = PERMISSIONS;

  const isRecalculate = rules.includes(INVENTORIES_CONTROL_RECALCULATE);
  const isClose = rules.includes(INVENTORIES_CLOSE);
  const isDelete = rules.includes(INVENTORIES_CONTROL_DELETE);
  const negativeInv = inventory?.config?.allowsNegativeInventory
  const classes = useStyles();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleGo = () => {
    hist.push("/admin/control-inventarios");
    dispatch(resetTableControls());
  };

  const getExistence = () => {
    dispatch(getInventoryExistence(inventory?.id));
  };
  const deleteInventory = (del = true) => {
    dispatch(closeDeleteInventory(inventory?.id, del, handleGo));
  };

  const handleDeleteInventory = () => {
    deleteInventory();
    setDeleteInventoryModal();
  };
  const handleCloseInventory = () => {
    deleteInventory(false);
    setCloseInventoryModal();
  };

  const handleGetTypeInventory = (type, key) => {
    const isClosed = inventory?.status === "CLOSED";
    const alreadyLoaded = inventory?.loaded[key];

    if (alreadyLoaded) return;

    if (key === "mobileInventory" && !isClosed) {
      dispatch(getInventoryByType(inventory?.id, type, key));
      dispatch(markInventoryLoaded(key));
      return;
    }

    if (key !== "mobileInventory" && key !== 'storagesInventory') {
      if (key === "localInventory") {
        dispatch(getInventoryByType(inventory?.id, type, key, units, tanks));
      } else {
        dispatch(getInventoryByType(inventory?.id, type, key));
      }
      dispatch(markInventoryLoaded(key));
    }
  };



  useEffect(() => {
    !inventory.id && hist.push("/admin/control-inventarios");
  }, [inventory, hist]);

  return (
    <>
      <GlobalBox
        icon={<StorageIcon />}
        title={
          <Typography>
            {
              negativeInv ?
                <strong>
                  Editar: Inventario - Planta: {station?.label} - Fecha:{" "}
                  {inventory?.date}{" "}
                  {inventory?.status === "CLOSED" && (
                    <strong
                      style={{
                        color: green[500],
                        marginLeft: 8,
                      }}
                    >
                      Inventario Cerrado
                    </strong>
                  )}
                </strong>
                :
                <div>
                  Editar: Inventario - Planta: {station?.label} - Fecha:{" "}
                  {inventory?.date}{" "}
                  {inventory?.status === "CLOSED" && (
                    <strong
                      style={{
                        color: green[500],
                        marginLeft: 8,
                      }}
                    >
                      Inventario Cerrado
                    </strong>
                  )}
                </div>

            }
          </Typography>
        }
        controls={
          <>
            <Typography
              variant="subtitle1"
              style={{
                // backgroundColor: blue[800],
                padding: 8,
                color: blue[800],
                fontWeight: "bold",
                borderRadius: 4,
                marginRight: 16,
              }}
            >
              Existencias Fisicas:{" "}
              {getDecimalFormat(inventory?.physicalExistance)} kgs
            </Typography>
            {inventory?.status !== "CLOSED" && (
              <>
                {isDelete && (
                  <RegularButton
                    round
                    justIcon
                    color="danger"
                    onClick={setDeleteInventoryModal}
                    tooltip="Eliminar Inventario"
                    size="sm"
                    disabled={isLoadingComp?.loadingInventoryExistence}
                  >
                    <DeleteSweepIcon />
                  </RegularButton>
                )}
                {
                  isRecalculate &&
                  <RegularButton
                    round
                    justIcon
                    color="dribbble"
                    onClick={getExistence}
                    tooltip="Recalcular"
                    size="sm"
                    disabled={isLoadingComp?.loadingInventoryExistence}
                  >
                    <CachedIcon />
                  </RegularButton>
                }
                {
                  isClose &&
                  <RegularButton
                    round
                    justIcon
                    color="success"
                    onClick={setCloseInventoryModal}
                    tooltip="Cerrar Inventario"
                    size="sm"
                  // disabled={isLoadingComp?.loadingInventoryExistence}
                  >
                    <AssignmentTurnedInIcon />
                  </RegularButton>
                }
              </>
            )}
            <RegularButton
              round
              justIcon
              color="info"
              onClick={handleGo}
              tooltip="Regresar"
              size="sm"
            >
              <ArrowBackIosIcon style={{ margin: 0, marginLeft: 8 }} />
            </RegularButton>
          </>
        }
      >
        <Box position="static">
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="full width tabs"
            indicatorColor="primary"
            textColor="primary"
          >
            {newInventoryTabs.map(
              ({ endpoint, label, edited, keyInventory }, idx) => (
                <Tab
                  wrapped
                  label={label}
                  {...a11yProps(idx)}
                  key={label + idx}
                  style={{
                    color: inventory[edited] && green[500],
                  }}
                  onClick={endpoint !== "shipment" ? () => handleGetTypeInventory(endpoint, keyInventory) : () => { }}
                />
              )
            )}
          </Tabs>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="full width tabs"
            textColor="primary"
            classes={{
              indicator: classes.disabledIndicator,
              root: classes.tabs,
            }}
          >
            <Tab
              wrapped
              label={`Total: ${getDecimalFormat(totalKgStorages)} kg`}
              disabled
              style={{ textAlign: "start" }}
            />
            <Tab
              wrapped
              label={`Total: ${getDecimalFormat(totalKgStationary)} kg`}
              disabled
              style={{ textAlign: "start" }}
            />
            <Tab
              wrapped
              label={`Total: ${getDecimalFormat(totalKgLocal)} kg`}
              disabled
              style={{ textAlign: "start" }}
            />
            <Tab
              wrapped
              label={`Total: ${getDecimalFormat(totalKgMobile) || 0} Kg`}
              disabled
              style={{ textAlign: "start" }}
            />
            <Tab
              wrapped
              label={`Total: ${getDecimalFormat(totalKgShipments) || 0} Kg`}
              disabled
              style={{ textAlign: "start" }}
            />
          </Tabs>
        </Box>
        {newInventoryTabs.map(({ content }, idx) => (
          <TabPanel value={value} index={idx} key={idx * 9}>
            {content ? content() : <Typography>sin pagina</Typography>}
          </TabPanel>
        ))}
      </GlobalBox>
      <ModalV2
        title="¿Eliminar inventario?"
        justConfirm
        open={deleteInventoryModal}
        onClose={setDeleteInventoryModal}
        flex
      >
        <RegularButton color="transparent" onClick={setDeleteInventoryModal}>
          Cancelar
        </RegularButton>
        <RegularButton color="danger" onClick={handleDeleteInventory}>
          Eliminar
        </RegularButton>
      </ModalV2>
      <ModalV2
        title="¿Cerrar inventario?"
        justConfirm
        open={closeInventoryModal}
        onClose={setCloseInventoryModal}
        flex
      >
        <RegularButton color="transparent" onClick={setCloseInventoryModal}>
          Cancelar
        </RegularButton>
        <RegularButton color="success" onClick={handleCloseInventory}>
          Confirmar
        </RegularButton>
      </ModalV2>
    </>
  );
};
